import { render } from "./DinosaurGameDemo.vue?vue&type=template&id=6146c75d&scoped=true"
import script from "./DinosaurGameDemo.vue?vue&type=script&lang=js"
export * from "./DinosaurGameDemo.vue?vue&type=script&lang=js"

import "./DinosaurGameDemo.vue?vue&type=style&index=0&id=6146c75d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6146c75d"]])

export default __exports__